module.exports = __webpack_public_path__ + "img/outlookIcon.87637ada.svg";